exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.plan-container[data-v-bf9d9a08] {\n  max-width: 50rem;\n  max-height: 35rem;\n}\n.cus-size[data-v-bf9d9a08] {\n  width: 50rem;\n  max-height: 35rem;\n}\n", ""]);

// exports
